import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';

// https://tools.hubteam.com/api-catalog/services/CrmUsages-Service/v2/spec/internal#operations-Crm_Usages_V2-post-%2Fcrm-usages%2Fv2%2Fusages%2F%7BchildType%7D%2Fparents%2Fstatistics%2F%7BobjectTypeId%7D
export const getUsages = objectTypeId => http.get(`crm-usages/v2/usages/PROPERTY/parents/statistics/${objectTypeId}?${`portalId=${PortalIdParser.get()}`}`).then(v => v.reduce((acc, {
  childName,
  numberOfUsages
}) => {
  const accumulatedCount = acc[childName];
  if (Number.isFinite(accumulatedCount)) {
    acc[childName] = accumulatedCount + numberOfUsages;
  } else {
    acc[childName] = numberOfUsages;
  }
  return acc;
}, {}));